// extracted by mini-css-extract-plugin
module.exports = {"contDestacatPrograma":"programesDestacats_contDestacatPrograma__A2p94"};